import { createRoot } from "react-dom/client";
import reportWebVitals from "./tests/reportWebVitals";
import { ControllerComponent } from "./Controller";
import "./css/style.css";

const root = createRoot(document.getElementById("root"));
root.render(<ControllerComponent />);

// Controller.init();
// Controller.loadMap();

/* ////////////////// */
/* Analytics          */
/* ////////////////// */
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
